import React from 'react'
import { CirclePause } from 'lucide-react'
import { SessionManager } from '../../utils'

export default function ActionPause(props) {

    const { text, route_name, onClick } = props

    var permission = JSON.parse(SessionManager.getSession('permission'))

    return (
        <>
            {(permission?.some(val => val.sub_action_name == route_name)) &&
                <CirclePause size={16} className='action-button text-primary me-2'
                    onClick={onClick}
                    data-tooltip-id="global-table-tooltip"
                    data-tooltip-content={text}
                    data-tooltip-place="bottom"
                    data-tooltip-class-name="bg-primary tooltip_msg"
                />
            }
        </>
    )
}
